require('./lbTooltip.scss');

const $inject = ['$sanitize'];

const lbTooltip = function ($sanitize) {
  return {
    controller: 'lbTooltipController',
    controllerAs: 'vm',
    bindToController: true,
    scope: {
      tooltipContent: '=',
      tooltipContentFunc: '=',
      tooltipLoadingText: '=',
      tooltipClass: '@',
      tooltipWidth: '@?',
      tooltipInline: '=?'
    },
    link: function(scope, element) {

      if(!scope.vm.tooltipContent && !scope.vm.tooltipContentFunc) {
        return false;
      }

      scope.el = element[0];
      scope.tooltip = document.createElement('div');
      scope.$tooltip = angular.element(scope.tooltip);
      scope.$tooltip.addClass(scope.vm.tooltipClass || 'tooltip');
      scope.isAsync = !!scope.vm.tooltipContentFunc;
      scope.isInline = !!scope.vm.tooltipInline;
      scope.tooltipWidth = scope.vm.tooltipWidth || 200;

      if(scope.isInline) {
        element.wrap('<div class="tooltipWrap"></div>');
        scope.wrap = element.parent();
      }

      if (scope.tooltipClass) {
        scope.$tooltip.addClass(scope.tooltipClass);
      }

      scope.$on(
        '$destroy',
        function handleDestroyEvent() {
          scope.el.removeEventListener('mouseenter', handleMouseEnter);
          scope.el.removeEventListener('mouseleave', handleMouseLeave);
          scope.$tooltip.remove();
        }
      );

      scope.el.addEventListener('mouseenter', handleMouseEnter);
      scope.el.addEventListener('mouseleave', handleMouseLeave);

      function buildTooltip() {
        let elDimensions = scope.el.getBoundingClientRect();
        let elPos = getPosition(scope.el);
        let leftOffset = elDimensions.width / 2;

        if(scope.isInline) {
          scope.docfrag = document.createDocumentFragment();
          scope.docfrag.appendChild(scope.tooltip);

          scope.$tooltip.css({
            bottom: elDimensions.height + 'px',
            left: elDimensions.width / 2 + 'px'
          });
        } else {
          scope.$tooltip.css({
            bottom: elPos.bottom + 'px',
            left: (elPos.left + leftOffset) + 'px',
            width: scope.tooltipWidth + 'px'
          });
        }

        if(!scope.isAsync){
          scope.tooltip.innerHTML = $sanitize(scope.vm.tooltipContent);
        } else {
          scope.tooltip.innerHTML = '<span class="tooltip-loading">' + (scope.vm.tooltipLoadingText || 'Loading...') + '</span>';
        }

        if(!scope.tooltipCached && scope.isAsync) {
          scope.$tooltip.addClass('loading');

          scope.vm.tooltipContentFunc().then(data => {
            scope.tooltipCached = true;
            scope.tooltip.innerHTML = $sanitize(data);
            scope.data = data;
            scope.$tooltip.removeClass('loading');
          });
        } else if(scope.isAsync) {
          scope.tooltip.innerHTML = scope.data;
        }

        if(scope.isInline) {
          scope.wrap.append(scope.docfrag);
        } else {
          document.body.appendChild(scope.tooltip);
        }
      }

      function getPosition(el) {
        let xPos = 0;
        let yPos = 0;

        while (el) {
          xPos += (el.offsetLeft + el.clientLeft);
          yPos += (el.offsetTop + el.clientTop);

          el = el.offsetParent;
        }

        return {
          left: xPos,
          top: yPos,
          bottom: document.body.offsetHeight - yPos
        };
      }

      function removeTooltip() {
        scope.$tooltip.removeClass('open');
        scope.$tooltip.remove();
      }

      function handleMouseEnter(){
        buildTooltip();
      }

      function handleMouseLeave(){
        removeTooltip()
      }

    }
  }
};

lbTooltip.$inject = $inject;

export default lbTooltip;



// WEBPACK FOOTER //
// ./src/directives/lbTooltip/lbTooltipDirective.js